//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      formattedData: '',
      nodes: [],
    };
  },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
  },
  created() {
    if (!this.event.additional) return;
    this.findNodes(this.event.additional, this.nodes);
  },
  methods: {
    findNodes(html, nodes, index = 0) {
      // Если в старом режиме вёрстка приходит без единого тега
      // то она ломается. Обрабатываем этот случай отдельно
      if (html.indexOf('<') === -1) {
        nodes.push({ title: '', content: html, hr: true });
        return;
      }

      const titleStart = html.indexOf('<h2');
      let titleEnd;
      let title;
      let htmlWithoutTitle;

      if (titleStart !== -1) {
        titleEnd = html.indexOf('</h2>');
        // Найти заголовок
        title = html.substr(titleStart, titleEnd - titleStart + 5);

        // Получить из заголовка только текст, без тега <h2
        const titleTextStart = title.indexOf('>') + 1;
        const titleTextEnd = title.lastIndexOf('</h2>') - 4;
        title = title.substr(titleTextStart, titleTextEnd);

        htmlWithoutTitle = html.substr(titleEnd + 5);
      } else {
        // Если заголовок не найден - весь текст, это текст без заголовка
        htmlWithoutTitle = html;
      }

      const contentStart = this.regexIndexOf(htmlWithoutTitle, /<\w+>/);
      let contentEnd = htmlWithoutTitle.indexOf('<h2');

      let content = '';
      if (contentEnd !== -1) {
        content = htmlWithoutTitle.substr(
          contentStart,
          contentEnd - contentStart,
        );
      } else {
        content = htmlWithoutTitle.substr(contentStart);
      }

      // На случай, если в конце контента остаются лишние теги <div
      contentEnd = content.lastIndexOf('</div>');
      if (contentEnd !== -1) {
        content = content.substr(0, contentEnd + 6);
      }

      // Если не помогло - считаем количество открывающихся и закрывающихся div
      const openDivCount = (content.match(/<div/g) || []).length;
      const closeDivCount = (content.match(/<\/div>/g) || []).length;

      if (openDivCount < closeDivCount) {
        const diff = closeDivCount - openDivCount;
        for (let i = 0; i < diff; i++) {
          content = '<div>' + content;
        }
      }
      if (closeDivCount < openDivCount) {
        const diff = openDivCount - closeDivCount;
        for (let i = 0; i < diff; i++) {
          content = content + '</div>';
        }
      }

      // Проверяем, есть ли hr в заголовке или в контенте
      // const hrInTitle = title.indexOf('<hr');
      // const hrInContent = content.indexOf('<hr');
      // const hr = hrInContent !== -1 || hrInTitle !== -1;
      const hr = true;

      nodes.push({ title, content, hr });

      // Проверяем, есть ли ещё заголовки, рекурсивно обрабатываем их
      const htmlWithoutContent = htmlWithoutTitle.substr(contentEnd);
      if (htmlWithoutContent.indexOf('<h2') !== -1) {
        this.findNodes(htmlWithoutContent, nodes, index);
      }
    },
    /**
     * Как indexOf, но для regex
     */
    regexIndexOf(string, regex, startpos) {
      var indexOf = string.substring(startpos || 0).search(regex);
      return indexOf >= 0 ? indexOf + (startpos || 0) : indexOf;
    },
  },
};
